
  import RuleNav from '~/components/about/rule-nav.vue'
  export default {
    //  红包管理规范页面
    name: 'Enveloperule',
    components: { RuleNav },
    layout: 'template-page',
    head() {
      return {
        title: '红包管理规范_问卷网',
      }
    },
  }
